import { Tag } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const FeatureIcon = createLucideIcon(Tag);
